module.exports = __webpack_public_path__ + "img/style_m.2735bc6d.png";